import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import Utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Util from './../../../shared/util/util';
import Treeselect from '@riophae/vue-treeselect';
import iptracker from '../../../../views/components/commonfunction/iptracker';


export default {
  name: 'updateInvoicedetails',
  components: {
    Treeselect,
    Paginate,
    BasicSelect,
    Utility,
    vueMultiSelect,
    iptracker,
    Loader
  },
  data: function() {
    return {
      userName:'',
      awb: '',
      InvoiceNumber:'',
      InvoiceValue:'',
      HsnCode:'',
      IsEwbnExempted:'',
      EWBNumber:'',
      invoicequantity:'',
      isLoading:false,
      showInvoiceQuantity:false,
      invoiceData:[],
      ewbDetailsList: {},
      EBNInfoPopup: false,
      EBNInfoErrorPopup: false,
      ewbDetailsErrorList:[],
      hsnlist:[],
      totalinvoicevalue:"",
      noofinvoices:"",
      EBNlimit:50000,
      form: {
        InvoiceNumber: [],
        InvoiceValue: [],
        EWBNumber: [],
        EWBExpiryDate: [],
        validated: [],
        isvalid: [],
        ishsnverified: [],
        EWBResponse: [],
        IsEwbnExempted: [],
        HsnCode: [],
        userdetail:{}
      },
      clientbusinessaccountid:null,
      clientid : null,
      bookingid : null,
      intrastate : null,
      comments:'',
      commentErr:''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userdetail = userdetail;
  },
  methods: {
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    clearValidateEwbFlag(id) {
      $("#InvoiceNumber"+id).removeClass('error')
      $("#EWBNumber"+id).removeClass('error')
      this.form.isvalid[id] = 0;
      this.form.EWBResponse[id] = "";
      this.form.ishsnverified[id] = 0;
      this.form.validated[id] = 0;
      this.form.EWBExpiryDate[id] ="";
    },
    openEBNInfoPopup(data) {
      this.EBNInfoPopup = true;
      this.ewbDetailsList = data.details;
      this.hsnlist = [];
      let tempArr = [];
      let hsnlist = data.details.itemList;
      for (var i = 0; i < hsnlist.length; i++) {
        let igstrate = 0;
        let cgstrate = 0;
        let sgstrate = 0;
        let gst = 0;
        if (hsnlist[i].igstRate != 0) {
          igstrate = (hsnlist[i].taxableAmount * hsnlist[i].igstRate) / 100;
          gst = hsnlist[i].igstRate;
        } else {
          if (hsnlist[i].cgstRate != 0) {
            cgstrate = (hsnlist[i].taxableAmount * hsnlist[i].cgstRate) / 100;
            gst = gst + hsnlist[i].cgstRate;
          }
          if (hsnlist[i].sgstRate != 0) {
            sgstrate = (hsnlist[i].taxableAmount * hsnlist[i].sgstRate) / 100;
            gst = gst + hsnlist[i].sgstRate;
          }
        }
        let tempObj = {
          "hsnCode": hsnlist[i].hsnCode,
          "GST": gst,
          "cgstRate": cgstrate.toFixed(2),
          "sgstRate": sgstrate.toFixed(2),
          "igstRate": igstrate.toFixed(2)
        }
        tempArr.push(tempObj);
      }
      this.hsnlist = tempArr;
    },
    openErrorEBNInfoPopup(data) {
      this.EBNInfoErrorPopup = true;
      this.ewbDetailsErrorList = data;
    },
    closeEBNInfoPopup() {
      this.EBNInfoPopup = false;
    },
    closeErrorEBNInfoPopup() {
      this.EBNInfoErrorPopup = false;
    },
    addnewrow(i){
      this.invoiceData.push({
        'InvoiceNumber': '',
        'InvoiceValue': '',
        'EWBNumber': '',
        'EWBExpiryDate':'' ,
        'validated': '',
        'isvalid': '',
        "EWBResponse": '',
        'IsEwbnExempted': 0,
        'HsnCode': '',
        'ishsnverified': '',
      });
      this.form.InvoiceNumber[i + 1] = ""
      this.form.InvoiceValue[i + 1] = ""
      this.form.EWBNumber[i + 1] = ""
      this.form.EWBExpiryDate[i + 1] = ""
      this.form.validated[i + 1] = 0
      this.form.isvalid[i + 1] = 0
      this.form.ishsnverified[i + 1] = 0
      this.form.EWBResponse[i + 1] = ""
      this.form.IsEwbnExempted[i + 1] = 0
      this.form.HsnCode[i + 1] = ""
    },
    deleteRow(index) {
      this.$confirm("Remove selected invoice detail.", '', 'question').then(() => {
        this.invoiceData.splice(index, 1);
        this.form.InvoiceNumber.splice(index, 1);
        this.form.InvoiceValue.splice(index, 1);
        this.form.EWBNumber.splice(index, 1);
        this.form.EWBExpiryDate.splice(index, 1);
        this.form.validated.splice(index, 1);
        this.form.isvalid.splice(index, 1);
        this.form.ishsnverified.splice(index, 1);
        this.form.EWBResponse.splice(index, 1);
      });
    },
  async getInvoiceDetails(){
    try {
      this.comments = '';
      this.commentErr = ''
      this.invoiceData = [];
      let InputPayload = {
        parentawb: this.awb
      }
      this.isLoading = true;
      let response = await Utility.getInvoiceDetails(InputPayload);
      if (response.data.code == 103) {
        this.isLoading = false;
        this.$alert(response.data.message, "", "error");
      }else{
        let invoicedata = response.data.data.data.ShipmentDetails[0].InvoiceDetails;
        this.bookingid = response.data.data.bookingid;
        this.clientid = response.data.data.clientid;
        this.clientbusinessaccountid = response.data.data.clientbusinessaccountid;
        this.intrastate = response.data.data.intrastate;
        if (response.data.data.intrastate == 1) {
          this.EBNlimit = 100000;
        }
        if (invoicedata && invoicedata.length > 0) {
          for (var i = 0; i < invoicedata.length; i++) {
            if (invoicedata[i]) {
              this.invoiceData.push({
                'InvoiceNumber': invoicedata[i].invoiceno,
                'InvoiceValue': invoicedata[i].invoicevalue,
                'EWBNumber': invoicedata[i].ewaybillsrnumber,
                'EWBExpiryDate': invoicedata[i].ebnexpirydate,
                'validated': (invoicedata[i].isewbnexempted == 'Yes') ? 0 : invoicedata[i].validated,
                'isvalid': (parseInt(invoicedata[i].invoicevalue) >= this.EBNlimit && invoicedata[i].validated == 1) ? 1 : 0,
                "EWBResponse": (parseInt(invoicedata[i].invoicevalue) >= this.EBNlimit && invoicedata[i].validated == 1) ? invoicedata.validatedresponse : null,
                'IsEwbnExempted': invoicedata[i].isebnexempted,
                'HsnCode': invoicedata[i].exemptedhsn,
                'ishsnverified': (invoicedata[i].isebnexempted == "Yes") ? 1 : 0,
              });
            }
          };
          invoicedata.forEach((item, index) => {
            this.form.InvoiceNumber[index] = item.invoiceno;
            this.form.InvoiceValue[index] = item.invoicevalue;
            this.form.EWBNumber[index] = item.ewaybillsrnumber;
            this.form.EWBExpiryDate[index] = (item.ebnexpirydate) ? Util.DateOnlyFormat(item.ebnexpirydate) : null;
            this.form.IsEwbnExempted[index] =(item.isebnexempted == "Yes") ? 1 : 0;
            this.form.HsnCode[index] = item.exemptedhsn;
            this.form.ishsnverified[index] = (item.isebnexempted == "Yes") ? 1 : 0;
            this.form.validated[index] =  0;
            this.form.isvalid[index] = 0;
            this.form.EWBResponse[index] = item.validatedresponse;
          });
          // this.noofinvoices = response.data.data.data.ShipmentDetails[0].noofinvoices;
        }else{
          this.invoiceData.push({
            'InvoiceNumber': '',
            'InvoiceValue': '',
            'EWBNumber': '',
            'EWBExpiryDate':'' ,
            'validated': '',
            'isvalid': '',
            "EWBResponse": '',
            'IsEwbnExempted': 0,
            'HsnCode': '',
            'ishsnverified': '',
          });
          this.form.InvoiceNumber[0] = ""
          this.form.InvoiceValue[0] = ""
          this.form.EWBNumber[0] = ""
          this.form.EWBExpiryDate[0] = ""
          this.form.validated[0] = 0
          this.form.isvalid[0] = 0
          this.form.ishsnverified[0] = 0
          this.form.EWBResponse[0] = ""
          this.form.IsEwbnExempted[0] = 0
          this.form.HsnCode[0] = ""
        }
      //  let noifinvoices = (this.bookingData.updatednoofinvoices) ? this.bookingData.updatednoofinvoices : this.bookingData.numberofinvoices;
      this.isLoading = false;
      }
    } catch (err) {
      this.isLoading = false;
      console.log(err);
    }
    },
    setname(id, name) {
      return name + id;
    },
    async validateEWB(id) {
      try {
        if (this.form.InvoiceNumber[id] == null || this.form.InvoiceNumber[id] == "") {
          this.$alert("Please enter Invoice Number", "", "error");
          return false;
        }
        if (this.form.InvoiceValue[id] == null || this.form.InvoiceValue[id] == "") {
          this.$alert("Please enter Invoice Value", "", "error");
          return false;
        }
        if (this.form.EWBNumber[id] == null || this.form.EWBNumber[id] == "") {
          this.$alert("Please enter EWB Number", "", "error");
          return false;
        }
        if(isNaN(this.form.EWBNumber[id]) || this.form.EWBNumber[id].length < 12) {
          this.$alert("EWB Number must be Numeric and Minimum 12 digits", "", "error");
          return false;
        }

         let InputPayload = {
          InvoiceNumber: this.form.InvoiceNumber[id],
          InvoiceValue: this.form.InvoiceValue[id],
          EWBNumber: this.form.EWBNumber[id]
        }
        this.isLoading = true;
        let result = await Utility.validateEWB(InputPayload);
        let responsedata = result.data.data;

        if (result.data.data.isvalid == true) {
          this.form.validated[id] = 1;
          this.form.isvalid[id] = 1;
          this.form.EWBResponse[id] = responsedata.data;

          let newdate;
          if (responsedata.data.details.validUpto) {
            let tempDate = responsedata.data.details.validUpto.split("-");
            let newDate = tempDate[1] + '/' + tempDate[2] + '/' + tempDate[0];
            newdate = Util.DateOnlyFormat(newDate);
          }
          this.form.EWBExpiryDate[id] = newdate;
        } else {
          this.form.validated[id] = 1;
          this.form.isvalid[id] = 2;
          this.form.EWBResponse[id] = result.data.data.errormessage;
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    validateAWB() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.getInvoiceDetails();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async saveinvoicedetails(){
      try {
        this.commentErr = ''
        var inputPayload = {
          comments:this.comments
        };
        let invoicedetails = [];
        let total = 0;
        let validinvoiceflag = 0;
        let invno = [];
        let ewbno = [];
        for (var i = 0; i < this.form.InvoiceNumber.length; i++) {
          $("#InvoiceNumber"+i).removeClass('error');
          $("#EWBNumber"+i).removeClass('error');
          if (this.form.InvoiceValue[i] >= this.EBNlimit && (this.form.IsEwbnExempted[i] == 0  && this.form.validated[i] == 0)) {
            validinvoiceflag = 1;
          }
          if ((this.form.EWBNumber[i] != null && this.form.EWBNumber[i] != "") && (this.form.IsEwbnExempted[i] == 0  && this.form.validated[i] == 0)) {
            validinvoiceflag = 1;
          }
          if (this.form.isvalid[i] == 2) {
            validinvoiceflag = 2;
          }
          if (this.form.IsEwbnExempted[i] == 1 && this.form.ishsnverified[i] == 0) {
            validinvoiceflag = 3;
          }
          if (this.form.IsEwbnExempted[i] == 1 && this.form.ishsnverified[i] == 2) {
            validinvoiceflag = 4;
          }
          total += parseFloat(this.form.InvoiceValue[i]);
          invoicedetails.push({
            InvoiceNumber: this.form.InvoiceNumber[i],
            InvoiceValue: this.form.InvoiceValue[i],
            EWBNumber: this.form.EWBNumber[i],
            EWBExpiryDate: (this.form.EWBExpiryDate[i]) ? this.form.EWBExpiryDate[i] : null,
            EWBValidate: (this.form.IsEwbnExempted[i] == 1 ? 0 : this.form.isvalid[i]),
            validatedresponse: (this.form.EWBResponse[i]) ? this.form.EWBResponse[i] : null,
            IsEwbnExempted: (this.form.IsEwbnExempted[i] == true ? 1 : 0),
            HsnCode: this.form.HsnCode[i]
          });
          if(invno.includes(this.form.InvoiceNumber[i])){
            $("#InvoiceNumber"+i).addClass('error');
          }
          invno.push(this.form.InvoiceNumber[i]);
          if (this.form.EWBNumber[i] != null && this.form.EWBNumber[i] != "") {
            if(ewbno.includes(this.form.EWBNumber[i])){
              $("#EWBNumber"+i).addClass('error');
            }
            ewbno.push(this.form.EWBNumber[i]);
          }
        }

        let uniqueinvno = invno.filter((v, i) => invno.indexOf(v) == i);
        if (uniqueinvno.length != invno.length) {
          this.$alert("Duplicates Invoice Numbers are exists", "", "error");
          return false;
        }

        let uniqueewbno = ewbno.filter((v, i) => ewbno.indexOf(v) == i);
        if (uniqueewbno.length != ewbno.length) {
          this.$alert("Duplicates EWB Numbers are exists", "", "error");
          return false;
        }
        this.totalinvoicevalue = total.toFixed(2);
        inputPayload.invoicedetails = invoicedetails;
        inputPayload.parentawb = this.awb;
        inputPayload.totalinvoicevalue = this.totalinvoicevalue;
        inputPayload.totalinvoices = invoicedetails.length;
        inputPayload.lastmodifiedby = this.userName;
        inputPayload.bookingid = this.bookingid ;
        inputPayload.clientid = this.clientid ;
        inputPayload.clientbusinessaccountid = this.clientbusinessaccountid ;
        inputPayload.intrastate = this.intrastate ;

        if (validinvoiceflag == 1) {
          this.$alert("Please validate EWB", "", "error");
          return false;
        } else if (validinvoiceflag == 2) {
          this.$alert("Invoice Details are not valid", "", "error");
          return false;
        } else if (validinvoiceflag == 3) {
          this.$alert("Please verify HSN code", "", "error");
          return false;
        } else if (validinvoiceflag == 4) {
          this.$alert("HSN Code Invalid", "", "error");
          return false;
        } else if (this.comments == ''){
          this.commentErr = 'Please enter comment'
        }else {
          this.isLoading = true;
          let result = await Utility.updateInvoiceDetailsInManifest(inputPayload);
          if (result.data.code == 200 ) {
            if (result.data.data.ReturnCode == 100) {
            this.getTraceIP(inputPayload)
            this.$alert(result.data.data.ReturnMessage, "", "success");
            }else{
              this.$alert(result.data.data.ReturnMessage, "", "error");
            }
          }else{
            this.$alert(result.data.message, "", "error");
          }
          this.isLoading = false;
        }

      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
  async saveInvoiceAndGSTDetails(){
    this.$validator.validateAll("invoicegstdetailsform").then((result) => {
      if (result) {
        this.saveinvoicedetails()
      }else {
        return false;
      }
    }).catch(() => {
      console.log('errors exist');
      return false;
    });
    },
    async verifyHsnCode(id) {
      try {
        if (this.form.HsnCode[id] == "" || this.form.HsnCode[id] == null) {
          this.$alert("Please enter HSN Code", "", "error");
          return false;
        }
        let InputPayload = {
          HsnCode: this.form.HsnCode[id]
        }
        this.isLoading = true;
        let result = await Utility.verifyHSN(InputPayload);
        if (result.data.data.ishsnverified == 1) {
          console.log(result.data.data.ishsnverified);
          this.form.ishsnverified[id] = 1;
        } else {
          this.form.ishsnverified[id] = 2;
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    clearHSNCheckFlag(id) {
      this.form.ishsnverified[id] = 0;
      if (this.form.IsEwbnExempted[id] == "1") {
        this.form.EWBNumber[id] = "";
        this.form.EWBExpiryDate[id] = "";
        this.form.isvalid[id] = 0;
        this.form.EWBResponse[id] = "";
      } else {
        this.form.HsnCode[id] = "";
      }
    },
    clearHSNFlag(id) {
      this.form.ishsnverified[id] = 0;
      this.form.isvalid[id] = 0;
      this.form.EWBResponse[id] = "";
    },

    reset() {
      this.awb = '';
      this.comments ='';
      this.invoiceData = [];
        this.form.InvoiceNumber = [];
        this.form.InvoiceValue = [];
        this.form.EWBNumber = [];
        this.form.EWBExpiryDate = [];
        this.form.validated = [];
        this.form.isvalid = [];
        this.form.ishsnverified = [];
        this.form.EWBResponse = [];
        this.form.IsEwbnExempted = [];
        this.form.HsnCode = [];
    },
    getTraceIP(data) {
      try {
        let payload = 
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/updateInvoiceDetails',
          "meta" : {
            "event" : `Update Invoice Details`,
            "data" : data
          }
      }
      let result = iptracker.getTraceIP(payload);
      } catch (error) {
        console.log(error)
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/updateInvoiceDetails/updateInvoiceDetails.component.js